import React from 'react';
import { Row } from 'antd';
import { isMobile } from 'react-device-detect';
import { selectTheme } from 'styles/theme/slice/selectors';
import { useSelector } from 'react-redux';

export default function HomeSectionContainer({
  children,
  divStyles,
  rowStyles,
  rowProps,
  disableRow,
}) {
  const customTheme = useSelector(selectTheme);

  return (
    <div
      style={{
        minHeight: !isMobile && '100vh',
        width: '100%',
        display: 'flex',
        backgroundColor: '#fafafa',
        // padding: isMobile ? '6vmin' : '8vmin',
        padding: '7%',
        color: customTheme.secondary,
        ...divStyles,
      }}
    >
      {!disableRow ? (
        <Row
          style={{
            maxWidth: !isMobile && '86vw',
            margin: isMobile ? '6vmin' : '4vmin auto',
            display: 'flex',
            flex: 1,
            ...rowStyles,
          }}
          {...rowProps}
        >
          {children}
        </Row>
      ) : (
        children
      )}
    </div>
  );
}
